
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website } from '@/services/Website/interfaces';
import { DnsCheckResult } from '@/services/DnsChecker';

@Component
export default class WebsiteDnsResult extends Vue {
  @Prop({ type: Object, required: true })
  public website!: Website;

  @Prop({ type: Object, required: true })
  public dns!: DnsCheckResult;
}
